import React from "react";
import { Autocomplete, TextField, Paper, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import useSharedStyles from "../../styles/Shared";
import ChevronDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { COLORS } from "../../themes/Base";

type OptionType = { label?: string; value?: string;[key: string]: any };

type Props = {
  label?: string;
  name?: string;
  value: any;
  options: OptionType[];
  onChange: (value: any) => void;
  getOptionLabel?: (option: OptionType) => string;
  getOptionValue?: (option: OptionType) => any;
  placeholder?: string;
  sx?: object;
  renderOption?: (props: React.HTMLAttributes<HTMLLIElement>, option: OptionType) => React.ReactNode;
  startAdornment?: React.ReactNode;
};

const AutoCompleteDropdown: React.FC<Props> = ({
  label,
  name,
  value,
  options,
  onChange,
  getOptionLabel = (option) => option.label ?? "",
  getOptionValue = (option) => option.value ?? "",
  placeholder,
  sx,
  renderOption,
  startAdornment,
}) => {
  const { classes } = useSharedStyles();
  return (
    <Autocomplete
      sx={sx}
      fullWidth
      options={options}
      getOptionLabel={getOptionLabel}
      value={options.find((opt) => getOptionValue(opt) === getOptionValue(value)) || null}
      onChange={(_, newValue) => onChange(newValue ? getOptionValue(newValue) : "")}
      renderOption={renderOption}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={placeholder || label}
          variant="outlined"
          fullWidth
          InputProps={{
            ...params.InputProps,
            name: name ?? params.inputProps?.name,
            startAdornment: typeof getOptionValue(value) === "undefined" || getOptionValue(value) === "" ? (
              startAdornment || (
                <InputAdornment position="start">
                  <SearchIcon color="action" sx={{ color: "#67676C", width: "20px" }} />
                </InputAdornment>
              )
            ) : null,
          }}
        />
      )}
      PaperComponent={(props) => (
        <Paper {...props} className={classes.innerBox} sx={{ fontSize: 14 }} />
      )}
      popupIcon={<ChevronDownIcon sx={{ color: COLORS.iconColor }} />}
      isOptionEqualToValue={(option, val) => getOptionValue(option) === getOptionValue(val)}
    />
  );
};

export default AutoCompleteDropdown;
